import { useEvent } from 'hooks'
import { createSelector } from 'selectors'

import { constant } from './constant'

export const DataGrid = (() => {
	const initInlineEditHandler = () => {
		const elements = createSelector<NodeListOf<HTMLElement>>(
			{
				selector: constant.selector.inlineEditElement,
			},
			true,
		)

		elements.forEach((element) => {
			const click = useEvent(element, 'click')

			click.register((event) => {
				const { target } = event.e

				if (target.tagName.toLowerCase() !== 'td' || target.classList.contains('editing')) {
					return
				}

				setTimeout(() => {
					const select = createSelector<HTMLElement | null>({
						scope: element,
						selector: 'select',
					})

					if (select === null) {
						return
					}

					const selectValue = target.getAttribute('data-datagrid-editable-value')

					if (selectValue !== null) {
						const selectedOption = createSelector<HTMLElement | null>({
							scope: select,
							selector: `option[value="${selectValue}"]`,
						})

						if (selectedOption !== null) {
							selectedOption.setAttribute('selected', '')
						}
					}

					const selectDropdown = M.FormSelect.init(select, {
						dropdownOptions: {
							container: document.body,
							onCloseEnd: () => {
								const blurEvent = new FocusEvent('blur', { bubbles: true })
								select.dispatchEvent(blurEvent)
							},
						},
					})
					selectDropdown.dropdown.open()
				}, 5)
			})
		})
	}

	const init = () => {
		initInlineEditHandler()
	}

	return {
		init,
	}
})()
